module.exports = __webpack_public_path__ + "img/drone.9f834f9f.svg";